import * as qs from 'qs';

const STORAGE_NAME_SPACE = 'nano-component-store:';

const urlRead = (
  from: 'hash' | 'query' = 'hash',
  win: Window = window
): void | object => {
  if (!win || !win.location) return {};
  if (from === 'hash' && win.location.hash)
    return qs.parse(win.location.hash.replace(/^\#/, ''), {
      strictNullHandling: true,
    });
  else if (from === 'query' && win.location.search)
    return qs.parse(win.location.search, { ignoreQueryPrefix: true });
  return {};
};

const urlSave = (
  object: object,
  to: 'hash' | 'query' = 'hash',
  win: Window = window,
  method: 'replace' | 'push' = 'replace'
) => {
  if (!win || !win.history) return;
  const oldQuery = to === 'query' ? win.location.search : win.location.hash;
  const basePath =
    to === 'query'
      ? win.location.pathname
      : win.location.pathname + win.location.search;
  let queryStr = qs.stringify(object, {
    strictNullHandling: true,
    addQueryPrefix: false,
    encodeValuesOnly: true,
  });

  if (!queryStr || !queryStr.length) {
    if (!oldQuery || !oldQuery.length) return;
    if (method === 'replace') win.history.replaceState(null, null, basePath);
    else win.history.pushState(null, null, basePath);
    return;
  }

  if (to === 'hash' && win.location.hash === '#' + queryStr) {
    try {
      (document.querySelector('#' + queryStr) as HTMLElement).focus();
    } catch (e) {}
    return;
  }
  queryStr = (to === 'hash' ? '#' : '?') + queryStr;
  if (queryStr === oldQuery) return;
  if (method === 'replace')
    win.history.replaceState(null, null, basePath + queryStr);
  else win.history.pushState(null, null, basePath + queryStr);
};

export const urlSet = (
  id: string,
  data: object,
  to: 'hash' | 'query' = 'hash',
  win: Window = window,
  method: 'replace' | 'push' = 'replace'
) => {
  // sanitize the incoming key
  id = Object.keys(qs.parse(id))[0];
  const object = {};
  object[id] = data;

  let currentData = urlRead(to, win);
  currentData = { ...currentData, ...object };
  urlSave(currentData, to, win, method);
};

export const urlGet = (
  key: string,
  to: 'hash' | 'query' = 'hash',
  win: Window = window
) => {
  // sanitize the incoming key
  key = Object.keys(qs.parse(key))[0];
  const currentData = urlRead(to, win);
  return currentData[key] || null;
};

export const sessionSet = (
  key: string,
  object: object,
  win: Window = window
) => {
  try {
    if (!object) {
      win.sessionStorage.removeItem(STORAGE_NAME_SPACE + key);
      return;
    }
    win.sessionStorage.setItem(
      STORAGE_NAME_SPACE + key,
      JSON.stringify(object)
    );
  } catch (e) {
    throw e;
  }
};

export const sessionGet = (key: string, win: Window = window) => {
  try {
    const configStr = win.sessionStorage.getItem(STORAGE_NAME_SPACE + key);
    return configStr !== null ? JSON.parse(configStr) : null;
  } catch (e) {
    throw e;
  }
};

export const storageSet = (
  key: string,
  object: object,
  win: Window = window
) => {
  try {
    if (!object) {
      win.localStorage.removeItem(STORAGE_NAME_SPACE + key);
      return;
    }
    win.localStorage.setItem(STORAGE_NAME_SPACE + key, JSON.stringify(object));
  } catch (e) {
    throw e;
  }
};

export const storageGet = (key: string, win: Window = window) => {
  try {
    const configStr = win.localStorage.getItem(STORAGE_NAME_SPACE + key);
    return configStr !== null ? JSON.parse(configStr) : null;
  } catch (e) {
    throw e;
  }
};
